<script setup lang="ts">
import type { ComponentSeoDescriptionsProps } from "./ComponentSeoDescriptions.props"
const props = defineProps<ComponentSeoDescriptionsProps>()
</script>

<template>
  <div class="cms-seo-description">
    <div class="grid-container gap-y-4">
      <TextBlocksSeoDescription
        v-bind="seoBlocks[0]"
        class="col-span-full md:col-span-5"
      />
      <TextBlocksSeoDescription
        v-bind="seoBlocks[1]"
        class="col-span-full md:col-span-7"
      />
    </div>
  </div>
</template>
